import { PlaceholderPage } from '../components/PlaceholderPage';

export const Listings = () => {
  return (
    <PlaceholderPage
      title="Manage Your Listings"
      description="Sign in as a venue admin to manage your winery's listing, hours, and tasting experiences. To claim a winery you operate, contact us at feedback@wineryxplorer.com."
    />
  );
};
